import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ae431386")

_pushScopeId("data-v-ae431386")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page__body" }
const _hoisted_3 = { class: "sponsor__group" }
const _hoisted_4 = {
  key: 0,
  class: "update__group"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SponsorAdd = _resolveComponent("SponsorAdd")
  const _component_SponsorsContent = _resolveComponent("SponsorsContent")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.canAddSponsor)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_SponsorAdd)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_SponsorsContent, {
          showTitle: false,
          showImg: false,
          sponsors: _ctx.sortedSponsors
        }, null, 8, ["sponsors"])
      ])
    ])
  ]))
})